<template>
    <div class="position-relative celebration">
        <UtilsContent @close-action="closeQuestion" content-width="55">
            <template v-slot:header>
                <div class="d-flex flex-row justify-start align-center mx-3 mb-4">
                    <img :src="questionsImg" class="img-index mr-2" alt="" /><span class="text-h5 ma-0 text--primary">{{
                            $t('bookReading.question')
                    }}</span>
                </div>
            </template>
            <template v-slot:content>
                <div class="d-flex flex-column questions-container" id="questions-container"
                    v-if="questionsForChapter.length">
                    <QuestionItem :data="currentQuestion" :item_type="itemType" :correct="selectedCorrect"
                        :cleanSelection="cleanCounter" :incorrect="selectedIncorrect" :isClassCorrect="isClassCorrect"
                        @newSelection="newSelection" ref="questionItem" />
                </div>
                <div class="d-flex flex-column questions-container" v-else>
                    <span class="text-h6 text--primary">No hay preguntas en este momento.</span>
                </div>
            </template>
            <template v-slot:actions v-if="questionsForChapter.length">
                <div v-if="!isInitialReader">
                    <v-btn color="secondary" rounded class="mt-5 py-5 px-10 text--white" @click="evaluateQuestion"
                        v-if="!asked && !secondChance"><span class="text--white text-capitalize">{{
                                $t('bookReading.answer')
                        }}</span></v-btn>
                    <v-btn v-if="secondChance" color="secondary" rounded class="mt-5 py-5 px-10 text--white"
                        @click="tryAgain"><span class="text--white text-capitalize">{{
                                $t('bookReading.try_again')
                        }}</span></v-btn>
                    <v-btn v-if="asked" @click="nextLot" color="secondary" rounded class="mt-5 py-5 px-10 text--white">
                        <span class="text--white text-capitalize">{{
                                $t('bookReading.continue')
                        }}</span>
                    </v-btn>
                </div>
                <div v-else>
                    <v-btn color="secondary" rounded class="mt-5 py-5 px-10 text--white" @click="validateQuestion"
                        v-if="!asked"><span class="text--white text-capitalize">{{
                                $t('bookReading.answer')
                        }}</span></v-btn>
                    <v-btn v-if="asked" @click="nextLot" color="secondary" rounded class="mt-5 py-5 px-10 text--white">
                        <span class="text--white text-capitalize">{{
                                $t('bookReading.continue')
                        }}</span>
                    </v-btn>
                </div>
            </template>
        </UtilsContent>
        <div :class="
            'position-absolute transition-all ' +
            (showOptions ? 'three-img-corner-button' : 'img-corner-button')
        " @click="showOptions = !showOptions" v-if="questionsForChapter.length && !isInitialReader"></div>
        <div class="position-absolute transition-all wildcard-button" v-if="showOptions && !isInitialReader"
            @click="openWildCardModal"></div>
        <div class="position-absolute transition-all tip-button" @click="showTips"
            v-if="showOptions && !isInitialReader"></div>
        <v-btn icon class="position-absolute transition-all cls-button" v-if="showOptions && !isInitialReader"
            @click="showOptions = !showOptions">
            <v-icon class="text--primary">mdi-close</v-icon>
        </v-btn>
        <audio id="correct_audio" :src="global.GAMIFICATION_SOUNDS + 'answer_correct.mp3'"
            crossOrigin="anonymous"></audio>
        <audio id="incorrect_audio" :src="global.GAMIFICATION_SOUNDS + 'answer_incorrect.mp3'"
            crossOrigin="anonymous"></audio>
        <audio id="tips_audio" :src="global.GAMIFICATION_SOUNDS + 'question_tip_used.mp3'"
            crossOrigin="anonymous"></audio>
        <audio id="wildcard_audio" :src="global.GAMIFICATION_SOUNDS + 'question_wildcard_used.mp3'"
            crossOrigin="anonymous"></audio>
        <app-footer parentComponent="questions" ref="appFooter" class="d-none" />
        <TipsModal v-if="currentTip" :dialog="showTipsModal" :tip_number="tipIndex + 1" :total_tips="tipsData.length"
            :tip_text="currentTip.detail" @close-modal="closeTipsModal" />
        <WildcardModal :dialog="showWildCardModal" :count_beecoins="coins" :wildcard_price="global.WILDCARD_PRICE"
            @close-modal="closeWildcardModal" @confirm="confirmBuyWildCard" />
        <WildcardUsedModal :dialog="showWildCardUsedModal" />
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState, mapActions } from 'vuex'
import global from '@/constants/GlobalConstant'

import AssessmentItemService from '@/services/bookAssessmentItem'

import { confetti } from 'dom-confetti'
import QuestionItem from './items/QuestionItem.vue'
import TipsModal from './modals/TipsModal.vue'
import WildcardModal from './modals/WildcardModal.vue'
import WildcardUsedModal from './modals/WildcardUsedModal.vue'

import SpeechSynthesis from "../../../../mixins/SpeechSynthesis";
import initialReaderValidation from "../../../../mixins/InitialReaderValidation";
import UtilsContent from "../../../core/utils/UtilsContent";
import { CONFETTI_SETUP } from "../../../../constants/DefaultConstants";

export default {
    components: {
        UtilsContent,
        QuestionItem,
        TipsModal,
        WildcardModal,
        WildcardUsedModal,
    },
    computed: {
        ...mapState({
            catalog: (state) => state.bookReading.catalog,
            indexItem: (state) => state.bookReading.indexItem,
            itemType: (state) => state.bookReading.itemType,
            currentQuestion: (state) => state.bookReading.currentQuestion,
            questionsForChapter: (state) => state.bookReading.questionsForChapter,
            indexQuestion: (state) => state.bookReading.indexQuestion,
            itemsData: (state) => state.bookReading.itemsData,
            streak: (state) => state.bookReading.streak,
            coins: (state) => state.userData.coins,
            points: (state) => state.userData.points,
            user: (state) => state.userData.user,
            tipsData: (state) => state.bookReading.tipsData,
            lastQuestionOfGroup: (state) => state.bookReading.lastQuestionOfGroup,
            lastQuestionOfBook: (state) => state.bookReading.lastQuestionOfBook,
            bookAssessmentData: (state) => state.bookReading.bookAssessmentData,
            isRecommended: (state) => state.bookReading.isRecommended,
            course: (state) => state.userData.user.course,
        }),
        isMultipleOption() {
            return this.itemType === 'CLOSED_4OPTIONS'
        }
    },
    data() {
        return {
            questionsImg: require('@/assets/img/icons/reading/3-questions.svg'),
            showOptions: false,
            secondChance: false,
            correct: false,
            passTryAgain: false,
            asked: false,
            usedWildcard: false,
            audioCorrect: 'correct_audio',
            audioIncorrect: 'incorrect_audio',
            audioUseWildcard: 'wildcard_audio',
            audioTips: 'tips_audio',
            showTipsModal: false,
            tipIndex: 0,
            currentTip: null,
            showWildCardModal: false,
            global,
            showWildCardUsedModal: false,
            selectedOption: {
                id: null,
                value: null,
                secret: null,
            },
            selectedCorrect: 0,
            selectedIncorrect: 0,
            isClassCorrect: false,
            cleanCounter: 0,
        }
    },
    methods: {
        ...mapActions('bookReading', [
            'setStreak',
            'setCurrentQuestion',
            'setQuestionForChapter',
            'setIndexItem',
            'setItemType',
            'hideAllUtils',
            'setHasQuestion',
            'setTipsData',
            'setLastQuestionOfGroup',
            'setLastQuestionOfBook',
        ]),
        ...mapActions('userData', ['setCoins', 'setPoints']),
        closeQuestion() {
            this.$emit('close-question')
        },
        celebrateSuccess(el = null) {
            if (el) confetti(el, CONFETTI_SETUP)
        },
        evaluateQuestion() {
            const value = this.evaluateValue(this.selectedOption)
            const { secret } = this.selectedOption
            if (value) {
                if (this.isMultipleOption) this.evaluateMultipleOption(value, secret);
                if (!this.isMultipleOption) this.evaluateTrueOrFalse(value, secret);
                window.ChurnZero.push(['trackEvent', 'answerBookQuestion', 'Send answer in book question']);
                this.$ga.event('userClick', 'answerBookQuestion')
            }
        },
        async validateQuestion() {
            if (this.evaluateValue(this.selectedOption)) {
                const { id, secret, value } = this.selectedOption;
                if (this.isCorrect(secret, value)) {
                    this.setSoundEffect();
                    this.$refs.questionItem.setCorrectAnswer(this.currentQuestion.id, this.isMultipleOption ? id : value);
                    this.handlePrize();
                    this.asked = true
                } else {
                    this.setSoundEffect(false);
                    this.$refs.questionItem.setWrongAnswer(this.currentQuestion.id, this.isMultipleOption ? id : value);
                    this.cleanOptions();
                }

                if (this.isMultipleOption) this.send4OptionRequest(value);
                if (!this.isMultipleOption) this.sendTrueOrFalseRequest(value === '1');

            }
        },
        setSoundEffect(success = true) {
            if (success) {
                this.playSound(this.audioCorrect);
                this.celebrateSuccess(document.querySelector('.celebration'));
            } else {
                this.playSound(this.audioIncorrect);
            }
        },
        isCorrect(item, value) {
            const first = item === 'true';
            const second = value === '1';
            if (!this.isMultipleOption) return first === second;
            if (this.isMultipleOption) return item ? item === parseInt(process.env.VUE_APP_VALUE_CORRECT_ANSWER, 10) : false
        },
        evaluateValue({ id = 0, value = null }) {
            if (id) return value;
            this.$modal.error(this.$t('initialTour.select_option'));
            return false;
        },
        send4OptionRequest(value) {
            AssessmentItemService.evaluateAssessmentAnswer4Options({
                catalogId: this.catalog.id,
                questionId: this.currentQuestion.id,
                trueOrFalse: null,
                answerId: value,
                usedWildcard: this.usedWildcard,
                streak: this.streak,
                lastQuestionOfGroup: this.lastQuestionOfGroup,
                lastQuestionOfBook: this.lastQuestionOfBook,
                recommended: this.isRecommended,
            }).catch(() => { /* ignored */ })
        },
        sendTrueOrFalseRequest(value) {
            AssessmentItemService.evaluateAssessmentAnswerTrueOrFalse({
                catalogId: this.catalog.id,
                questionId: this.currentQuestion.id,
                trueOrFalse: value,
                answerId: null,
                usedWildcard: this.usedWildcard,
                streak: this.streak,
                lastQuestionOfGroup: this.lastQuestionOfGroup,
                lastQuestionOfBook: this.lastQuestionOfBook,
                recommended: this.isRecommended,
            }).catch(() => { /* ignored */ })
        },
        handlePrize() {
            this.setStreak(this.streak + 1)
            this.setCoins(this.coins + this.streak)
            this.setPoints(this.points + Number.parseInt(process.env.VUE_APP_BEECOINS_CORRECT_ANSWER_BOOKS, 10))
        },
        evaluateMultipleOption(value, secret) {
            // Persists answer
            this.send4OptionRequest(value);

            const el = document.querySelector('.celebration')
            // Correct answer
            if (secret === Number.parseInt(process.env.VUE_APP_VALUE_CORRECT_ANSWER, 10)) {
                confetti(el, CONFETTI_SETUP)
                this.playSound(this.audioCorrect)
                this.asked = true
                this.secondChance = false
                this.handlePrize();
                this.selectedCorrect = value
                return
            }

            // Incorrect answer
            this.playSound(this.audioIncorrect)
            this.setStreak(0)
            this.selectedIncorrect = value
            // Already passed second chance or the clone question doesn't exists
            if (this.passTryAgain || !AssessmentItemService.findCloneQuestion(this.questionsForChapter)) {
                this.passTryAgain = true
                this.asked = true
                this.isClassCorrect = true
                this.secondChance = false
                this.showCorrectAnswer()
                return
            }
            // Go to second chance (there's a clone question)
            this.secondChance = true
        },
        evaluateTrueOrFalse(userSelectedOption, secret) {

            const el = document.querySelector('.celebration')
            const isUserSelectedOptionTrue = (userSelectedOption === '1')

            // Persists answer
            this.sendTrueOrFalseRequest(isUserSelectedOptionTrue);

            // Correct answer
            if (userSelectedOption == secret) {

                confetti(el, CONFETTI_SETUP)
                this.playSound(this.audioCorrect)
                this.asked = true
                this.secondChance = false
                this.handlePrize()
                this.selectedCorrect = userSelectedOption
                return
            }

            // Incorrect answer
            this.playSound(this.audioIncorrect)
            this.setStreak(0)
            this.selectedIncorrect = userSelectedOption
            // Already passed second chance or the clone question doesn't exists
            if (this.passTryAgain || !AssessmentItemService.findCloneQuestion(this.questionsForChapter)) {
                this.passTryAgain = true
                this.asked = true
                this.isClassCorrect = true
                this.secondChance = false
                return
            }
            // Go to second chance (there's a clone question)
            this.secondChance = true
        },
        newSelection(selectionParam) {
            this.selectedOption = selectionParam
        },
        nextLot() {
            const { ordinalGrade } = this.user.course;
            this.cleanOptions();
            this.setIndexItem(this.indexItem + 1);
            this.$refs.questionItem.cleanStyles();
            if (this.indexItem <= this.itemsData.length - 1) {
                this.cleanCorrectAnswer()
                this.setQuestionForChapter(this.itemsData[this.indexItem].questions)
                this.setCurrentQuestion(this.questionsForChapter[0])
                this.setItemType(this.itemsData[this.indexItem].itemType)
                this.setTipsData(
                    this.$refs.appFooter.filterByGrade(
                        this.itemsData[this.indexItem].aimOfAssessment.tips,
                        ordinalGrade
                    )
                )
                const index = this.bookAssessmentData.indexOf(this.itemsData[this.indexItem])
                this.setLastQuestionOfGroup(this.indexItem === this.itemsData.length - 1)
                this.setLastQuestionOfBook(index === this.bookAssessmentData.length - 1)
                this.asked = false
                this.passTryAgain = false
                this.secondChance = false
                this.usedWildcard = false
                this.tipIndex = 0
                const indexToDelete = this.bookAssessmentData.indexOf(
                    this.itemsData[this.indexItem - 1]
                )
                this.bookAssessmentData.splice(indexToDelete, 1)
            } else {
                this.setQuestionForChapter([])
                this.setCurrentQuestion(null)
                this.setItemType(null)
                this.setTipsData([])
                this.asked = false
                this.passTryAgain = false
                this.secondChance = false
                this.setHasQuestion(false)
                this.hideAllUtils()
                this.tipIndex = 0
                this.currentTip = null
                this.usedWildcard = false
                this.setIndexItem(0)
                this.$refs.appFooter.next()
            }
        },
        tryAgain() {
            this.cleanOptions()
            this.setCurrentQuestion(this.questionsForChapter[1])
            this.asked = false
            this.secondChance = false
            this.usedWildcard = false
            this.passTryAgain = true
        },
        cleanOptions() {
            this.selectedOption = {
                id: null,
                value: null,
                secret: null,
            }
            this.selectedCorrect = 0
            this.selectedIncorrect = 0
            this.isClassCorrect = false
            this.cleanCounter += 1
            document.querySelectorAll('.hide-option').forEach((el) => {
                el.classList.toggle('hide-option')
            })
        },
        playSound(player) {
            document.getElementById(player).play()
        },
        showTips() {
            if (this.tipIndex <= this.tipsData.length - 1) {
                this.playSound(this.audioTips)
                this.currentTip = this.tipsData[this.tipIndex]
                this.showTipsModal = true
                this.showOptions = false
                return
            }
            this.showOptions = false
            this.showTipsModal = false
            this.$modal.warning('Ya has utilizado todas las pistas para esta pregunta.')
        },
        closeTipsModal() {
            this.showTipsModal = false
            this.showOptions = false
            this.tipIndex += 1
        },
        closeWildcardModal() {
            this.showWildCardModal = false
            this.usedWildcard = false
        },
        confirmBuyWildCard() {
            if (this.coins < this.global.WILDCARD_PRICE) {
                this.$modal.error(this.$t('bookReading.without_beecoins'))
                return
            }
            const vm = this
            this.playSound(this.audioUseWildcard)
            this.setCoins(this.coins - this.global.WILDCARD_PRICE)
            const optionsToHide = this.currentQuestion.answers.filter(
                (answer) => answer.itemNumber !== 4
            )
            optionsToHide.forEach((opt, index) => {
                if (index === 1 || index === 0) {
                    const el = document.getElementById(opt.id)
                    if (el) el.classList.toggle('hide-option')
                }
            })

            this.usedWildcard = true
            this.showOptions = false
            this.showWildCardModal = false
            this.showWildCardUsedModal = true
            setTimeout(() => {
                vm.showWildCardUsedModal = false
            }, 5000)
        },
        openWildCardModal() {
            if (this.itemType === 'CLOSED_TRUE_FALSE') {
                this.$modal.error(
                    this.$t('bookReading.multiple_selection_only')
                )
                return
            }

            if (this.usedWildcard) {
                this.$modal.error(this.$t('bookReading.wildcard_alredy_use'))
                return
            }
            this.showWildCardModal = true
            this.showOptions = false
        },
        showCorrectAnswer() {
            const correctAnswer = this.currentQuestion.answers.find(
                (answer) => answer.itemNumber === parseInt(process.env.VUE_APP_VALUE_CORRECT_ANSWER, 10)
            );
            if (correctAnswer) {
                const { id } = correctAnswer
                const el = document.getElementById(id)
                if (!el) return;

                el.classList.toggle('correct')
                el.classList.toggle('white--text')
                el.classList.toggle('primary--text')

            }
        },
        cleanCorrectAnswer() {
            const el = document.querySelector('.correct')
            if (el) {
                el.classList.toggle('correct')
                el.classList.toggle('white--text')
                el.classList.toggle('primary--text')
            }
        },
    },
    mixins: [SpeechSynthesis, initialReaderValidation]
}
</script>
<style>
.questions-container {
    max-height: 70vh;
    overflow: auto;
}

.img-corner-button {
    background: url(../../../../assets/img/gamifications/comodin-001.svg);
    background-repeat: round;
    z-index: 11;
}

.img-corner-button:hover {
    background: url(../../../../assets/img/gamifications/comodin-003.svg);
    background-repeat: round;
    cursor: pointer;
}

.three-img-corner-button {
    background: url(../../../../assets/img/gamifications/comodin-004.svg);
    background-repeat: round;
    cursor: pointer;
    z-index: 11;
}

.wildcard-button {
    background: url(../../../../assets/img/gamifications/50-50.svg);
    background-repeat: round;
    cursor: pointer;
    z-index: 11;
}

.tip-button {
    background: url(../../../../assets/img/gamifications/pistas.svg);
    background-repeat: round;
    cursor: pointer;
    z-index: 11;
}

.cls-button {
    z-index: 11;
    bottom: 17.5vh;
    left: 1vh;
}

.wildcard-button:hover,
.tip-button:hover {
    bottom: 2.5em;
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
    .questions-container {
        max-height: 50vh;
        overflow: auto;
    }

    .img-corner-button {
        bottom: -10vh;
        left: -10vh;
        z-index: 11;
        width: 25vh;
        height: 25vh;
        padding: 8vh;
    }

    .img-corner-button:hover {
        bottom: -10vh;
        left: -10vh;
        width: 25vh;
        height: 25vh;
        padding: 8vh;
    }

    .three-img-corner-button {
        bottom: -10vh;
        left: -10vh;
        width: 25vh;
        height: 25vh;
        padding: 8vh;
    }

    .wildcard-button {
        bottom: 2vh;
        left: 0vh;
        z-index: 11;
        width: 18vh;
        height: 18vh;
    }

    .tip-button {
        bottom: 2vh;
        left: -14vh;
        z-index: 11;
        width: 18vh;
        height: 20vh;
    }

    .wildcard-button:hover,
    .tip-button:hover {
        bottom: 2.5vh;
    }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
    .questions-container {
        max-height: 55vh;
        overflow: auto;
    }

    .img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        padding: 11.5vh;
    }

    .img-corner-button:hover {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        padding: 11.5vh;
    }

    .three-img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        padding: 11.5vh;
    }

    .wildcard-button {
        bottom: 2vh;
        left: -2.5vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
    }

    .tip-button {
        bottom: 2vh;
        left: -15vh;
        z-index: 11;
        width: 15vh;
        height: 16.5vh;
    }

    .wildcard-button:hover,
    .tip-button:hover {
        bottom: 2.5vh;
    }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    .questions-container {
        max-height: 70vh;
        overflow: auto;
    }

    .img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 22.5vh;
        height: 22.5vh;
        padding: 10vh;
    }

    .img-corner-button:hover {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 22.5vh;
        height: 22.5vh;
        padding: 10vh;
    }

    .three-img-corner-button {
        bottom: -9vh;
        left: -9vh;
        z-index: 11;
        width: 22.5vh;
        height: 22.5vh;
        cursor: pointer;
        padding: 10vh;
    }

    .wildcard-button {
        bottom: 2vh;
        left: 1vh;
        z-index: 11;
        width: 15vh;
        height: 15vh;
        cursor: pointer;
    }

    .tip-button {
        bottom: 2vh;
        left: -9vh;
        z-index: 11;
        width: 12vh;
        height: 16vh;
        cursor: pointer;
    }

    .wildcard-button:hover,
    .tip-button:hover {
        bottom: 3.5vh;
    }
}

.hide-option {
    display: none !important;
    clear: both;
}
</style>
